import { render } from "./AguaView.vue?vue&type=template&id=596c2b0b"
import script from "./AguaView.vue?vue&type=script&lang=js"
export * from "./AguaView.vue?vue&type=script&lang=js"

import "./AguaView.vue?vue&type=style&index=0&id=596c2b0b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__